import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../../utils/checkout';
import { pricingRows, pricingTrustItems } from '../../data/pricing';
export function Pricing() {
  return <section id="oferta-base" className="bg-bg-primary py-10 sm:py-14" data-id="element-188" data-mp="3gijjanzpi1ed">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-189" data-mp="3gkmh3u73oytn">
        <SectionTag icon="💰" data-id="element-190" data-mp="3lhcvmd39bmcy">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-191" data-mp="3pj7yvn4r09td">
          ¿Cuánto vale para ti recuperar tu tiempo libre?
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-192" data-mp="3c9mmha66q79">
          Acceso inmediato y garantía de 7 días.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-193" data-mp="205cv6seofrg4">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border border-lime/30 bg-bg-secondary p-6 sm:p-7" data-id="element-194" data-mp="206wbuk48w4if">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-195" data-mp="16ip56hi50ola">
            ⚽ MISTER PRO · 6 tomos + 5 bonos
          </p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-196" data-mp="xjva4vkgg69u">
            Sesiones completas · Más de 150 ejercicios y fichas prácticas · Diagramas, correcciones y mapa
            de 36 semanas.
          </p>

          <div className="mt-4 space-y-1.5" data-id="element-197" data-mp="1pa9lak1334ht">
            {pricingRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-white/5 py-1.5 text-sm" data-id="element-198" data-mp="1l8o44mhio41t">
                <span className="text-white/80" data-id="element-199" data-mp="1gc5wneusxrls">{row.content}</span>
                <span className="flex flex-shrink-0 items-center gap-2" data-id="element-200" data-mp="9vc46movo5kx">
                  {row.value !== '—' && <span className="text-muted" data-id="element-201" data-mp="4t39nlwcwvgp">{row.value}</span>}
                  <CheckIcon size={14} className="text-success" data-id="element-202" data-mp="6bk1trbg5c35" />
                </span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-white" data-id="element-203" data-mp="b9lkwc8vhbem">
              <span data-id="element-204" data-mp="3tfrlyjb0qg1t">VALOR TOTAL</span>
              <span data-id="element-205" data-mp="3tivs3m81nlv4">119,40€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-206" data-mp="1b5t0720ty42">Precio hoy (88% de descuento):</p>
          <p className="font-heading text-5xl font-bold text-lime sm:text-6xl" data-id="element-207" data-mp="3jp59uz2ig7nv">13,99€</p>
          <p className="mt-2 text-sm text-orange" data-id="element-208" data-mp="3oi865eyo9v7r">⏰ Precio de lanzamiento — sube pronto</p>

          <div className="mt-6" data-id="element-209" data-mp="39tldycny58z4">
            <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-lime px-8 py-4 font-heading text-base font-semibold uppercase tracking-wide text-bg-primary transition-all duration-200 hover:bg-lime-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary sm:text-lg" data-id="element-210" data-mp="39ud8rl9pz2oc">
              Quiero MISTER PRO por 13,99€
            </a>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-211" data-mp="2v5lekm3de86w">
            {pricingTrustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-212" data-mp="2r2oroj6srpx5">
                <item.icon size={12} data-id="element-213" data-mp="3539dlo80e1uv" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}